export default __webpack_public_path__ + "static/media/5.dd55cfda.jpeg";